import React, { Component } from 'react';
import { FormGroup, ControlLabel, Col, FormControl, HelpBlock } from 'react-bootstrap';
import moment from 'moment';
import DatePicker from '../../../public/vendor/react-bootstrap-date-picker';

export default class DateField extends Component {
	render() {
		const {
			placeholder,
			input,
			disabled,
			meta: { error, touched },
			label,
			id,
			layout,
			placement,
			minDate,
			maxDate,
			autoComplete,
		} = this.props;

		const showError = error && touched;

		const inputBlock = () => {
			return (
				<div>
					<DatePicker
						id={`dateinput-${input.name}`}
						name={input.name}
						placeholder={placeholder}
						value={input.value}
						disabled={disabled}
						onChange={input.onChange}
						minDate={ minDate && moment(minDate).toISOString()}
						maxDate={ maxDate && moment(maxDate).toISOString()}
						autoComplete={autoComplete ? 'on' : 'off'}
						calendarPlacement={placement || 'bottom'}
					/>
					<FormControl.Feedback />
					<HelpBlock>{showError ? error : ''}</HelpBlock>
				</div>
			);
		};

		if (layout === 'horizontal') {
			return (
				<FormGroup controlId={id || input.name} validationState={showError ? 'error' : null}>
					<Col componentClass={ControlLabel} xs={3} className="control-label-horizontal">
						{label}
					</Col>
					<Col xs={9}>
						{inputBlock()}
					</Col>
				</FormGroup>
			);
		}

		return (
			<FormGroup
				controlId={id || input.name}
				className={label ? 'label-present' : 'label-blank'}
				validationState={showError ? 'error' : null}
			>
				{label ? <ControlLabel>{label}</ControlLabel> : ''}
				{inputBlock()}
			</FormGroup>
		);
	}
}
